import {Component, Input, OnInit} from '@angular/core';
import {StepperReadyEvent, StepperService} from '@mydocma/import-export';
import {BehaviorSubject} from 'rxjs';
import {reportStepperConfig} from '../steps/faults-report-stepper.config';
import {FaultReportConfig} from '../../faults-report.config';
import {reportStepperOptions} from '../steps/faults-report-stepper.options';


@Component({
  selector: 'mydocma-mm-report-stepper',
  templateUrl: './report-stepper.component.html',
  styleUrls: ['./report-stepper.component.scss']
})
export class ReportStepperComponent implements OnInit  {

  @Input() reportConfig: FaultReportConfig;
  @Input() mobileMode = false;

  private stepperServiceSubject = new BehaviorSubject<StepperService>(null);
  stepperService$ = this.stepperServiceSubject.asObservable();

  stepperConfig = reportStepperConfig;
  stepperOptions = reportStepperOptions;

  private steperService: StepperService;

  constructor() { }

  ngOnInit() {
  }

  onReadyEvent(event: StepperReadyEvent) {
    this.steperService = event.stepperService;
    this.stepperServiceSubject.next(this.steperService);
  }
}
